module.exports = __webpack_public_path__ + "img/dzbh-bg.4cc10ca.png";